/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export const enum SalesOrderStatus {
  PAID = "Paid",
  PENDING = "Pending",
  CANCELED = "Canceled",
}
